import { render } from "./Loader.vue?vue&type=template&id=282ff8bd"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=282ff8bd&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__